import { render } from "./IndustryidxTrend.vue?vue&type=template&id=8c655854&scoped=true"
import script from "./IndustryidxTrend.vue?vue&type=script&lang=js"
export * from "./IndustryidxTrend.vue?vue&type=script&lang=js"

import "./IndustryidxTrend.vue?vue&type=style&index=0&id=8c655854&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c655854"]])

export default __exports__